// @flow
import styled from '@emotion/styled';
import { COLORS, SPACING } from '@tablekit/theme';
import { CallToActionBackground } from 'components/CallToAction';
import { MOBILE_BREAKPOINT } from 'utils/theme';
import type { BlogConfigType } from 'components/types';
import BlogAggregateCategory from '../AggregateCategory';
import type { BlogRelatedType } from './types';

type PropsType = {
  blogConfig: BlogConfigType,
  config: BlogRelatedType
};

const RelatedPostsWrapper = styled.div`
  background: ${COLORS.GRAY.L2};
  padding: ${SPACING.L9} 0;
  display: flex;
  align-items: stretch;
  flex-direction: column;

  @media ${MOBILE_BREAKPOINT} {
    width: 100%;
    padding: ${SPACING.L6} 0;
  }
`;

const RelatedPosts = ({
  blogConfig,
  config: { posts, title, link, see_more: seeMore }
}: PropsType) => (
  <RelatedPostsWrapper>
    <BlogAggregateCategory
      blok={{
        _editable: '',
        _uid: '',
        component: '',
        categories: [],
        posts,
        title,
        see_more_link: link,
        see_more_link_text: seeMore,
        max_count: '3',
        show_author: blogConfig.show_author,
        show_categories: blogConfig.show_categories,
        show_preview_text: blogConfig.show_preview_text,
        show_read_time: blogConfig.show_read_time,
        show_published_date: blogConfig.show_published_date
      }}
      align="left"
      shouldShowSeeMoreArrow
    />
    <CallToActionBackground />
  </RelatedPostsWrapper>
);

export default RelatedPosts;
